import { useRef } from "react";

function Table({ children }) {
  const tableRef = useRef(null);

  return (
    <div className="grid flex-col overflow-y-hidden">
      <div className="overflow-x-auto overflow-y-hidden sm:mx-0.5 lg:mx-0.5">
        <div className="min-w-full">
          <div
            className={`overflow-x-auto border border-gray-200 rounded-[4px] scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100`}
          >
            <div ref={tableRef}>
              <table className="min-w-full">{children}</table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Table;
